import React, { useEffect, useState } from "react";
import DateFilter from "./DateFilter";
import "./viewwork.css";
import { API } from "../../config/api";
const RatingStars = ({ rating, ratingCount, totalStars }) => {
  const value = Number(rating || 0);
  const count = Number(ratingCount || 0);
  const stars = Number(totalStars || 0);

  return (
    <div className="vwk-rating-wrapper">
      <div className="vwk-rating-stars">
        {[1, 2, 3, 4, 5].map((star) => {
          let icon = "bi-star";

          if (value >= star) {
            icon = "bi-star-fill";
          } else if (value >= star - 0.5) {
            icon = "bi-star-half";
          }

          return (
            <i
              key={star}
              className={`bi ${icon} ${
                icon === "bi-star" ? "vwk-star-empty" : "vwk-star-active"
              }`}
            ></i>
          );
        })}
      </div>

      <span className="vwk-rating-number">
        {value > 0 ? value.toFixed(1) : "No rating"}
      </span>

      {/* <span className="vwk-rating-count">({count})</span> */}

      {/* <span className="vwk-total-stars">Total Stars: {stars}</span> */}
    </div>
  );
};
export default function Viewwork() {
  const BASE_URL = `${API.BASE_URL}/api.php`;
  const BASE_URL1 = `${API.BASE_URL}/payment.php`;
  const UPLOAD_URL = `${API.BASE_URL}/uploads/work`;

  // Main navigation tab: "works" | "payments"
  const [activeTab, setActiveTab] = useState("works");

  // Works state
  const [works, setWorks] = useState([]);
  const [filter, setFilter] = useState("All");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showBidModal, setShowBidModal] = useState(false);
  const [selectedWork, setSelectedWork] = useState(null);
  const [commission, setCommission] = useState("");
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [showEditWorkModal, setShowEditWorkModal] = useState(false);
  const [editingWork, setEditingWork] = useState(null);

  const [editWorkData, setEditWorkData] = useState({
    description: "",
    height: "",
    area: "",
    color: "",
    existing_images: [],
    new_images: [],
  });

  const [editWorkSaving, setEditWorkSaving] = useState(false);
  const openEditWorkModal = (work) => {
    setEditingWork(work);

    setEditWorkData({
      description: work.description || "",
      height: work.height || "",
      area: work.area || "",
      color: work.color || "",
      existing_images: Array.isArray(work.images) ? [...work.images] : [],
      new_images: [],
    });

    setShowEditWorkModal(true);
  };
  const removeExistingWorkImage = (index) => {
    setEditWorkData((prev) => ({
      ...prev,
      existing_images: prev.existing_images.filter((_, i) => i !== index),
    }));
  };
  const removeNewWorkImage = (index) => {
    setEditWorkData((prev) => ({
      ...prev,
      new_images: prev.new_images.filter((_, i) => i !== index),
    }));
  };
  const handleUpdateWork = async () => {
    if (!editingWork) return;

    try {
      setEditWorkSaving(true);

      const formData = new FormData();

      formData.append("id", editingWork.id);
      formData.append("owner_id", editingWork.owner_id);

      formData.append("description", editWorkData.description || "");

      formData.append("height", editWorkData.height || "");

      formData.append("area", editWorkData.area || "");

      formData.append("color", editWorkData.color || "");

      // Existing images that user has NOT removed
      formData.append(
        "existing_images",
        JSON.stringify(editWorkData.existing_images),
      );

      // New selected images
      editWorkData.new_images.forEach((file) => {
        formData.append("images[]", file);
      });

      const response = await fetch(`${BASE_URL}?action=update_work`, {
        method: "POST",
        body: formData,
      });

      const text = await response.text();

      console.log("Update Work Response:", text);

      let result;

      try {
        result = JSON.parse(text);
      } catch (error) {
        console.error("Invalid JSON:", text);
        alert("Server returned invalid JSON.");
        return;
      }

      alert(result.message);

      if (result.status) {
        setShowEditWorkModal(false);
        setEditingWork(null);

        setEditWorkData({
          description: "",
          height: "",
          area: "",
          color: "",
          existing_images: [],
          new_images: [],
        });

        await getWorks(false);
      }
    } catch (error) {
      console.error("Update work error:", error);
      alert("Failed to update work.");
    } finally {
      setEditWorkSaving(false);
    }
  };
  const [selectedDescription, setSelectedDescription] = useState({
    description: "",
    height: "",
    area: "",
    color: "",
    designType: "",
  });
  const [newBidWorks, setNewBidWorks] = useState([]);
  const [newBidPopup, setNewBidPopup] = useState([]);
  const [profilePreview, setProfilePreview] = useState(null);
  const [showAcceptedActionModal, setShowAcceptedActionModal] = useState(false);

  const [selectedAcceptedWork, setSelectedAcceptedWork] = useState(null);
  // Payments state
  const [payments, setPayments] = useState([]);
  const [editingPayment, setEditingPayment] = useState(null);
  const [showEditPaymentModal, setShowEditPaymentModal] = useState(false);

  // Lightbox Preview state
  const [previewData, setPreviewData] = useState(null);
  // Hover Image Preview
  const [hoverPreview, setHoverPreview] = useState({
    image: null,
    left: 0,
    top: 0,
  });
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [paymentData, setPaymentData] = useState({
    work_id: "",
    bid_id: "",
    designer_id: "",
    amount: "",
    payment_mode: "Bank",
    transaction_no: "",
    payment_date: new Date().toISOString().split("T")[0],
    remarks: "",
  });
  const getDescriptionData = (description = "") => {
    const selectedTypes = [];
    let remainingDescription = description;

    DESIGN_TYPES.forEach((type) => {
      const regex = new RegExp(`(^|,|\\n)\\s*${type}\\s*(?=,|\\n|$)`, "gi");

      if (regex.test(description)) {
        selectedTypes.push(type);
      }

      // Reset regex and remove only selected design types
      remainingDescription = remainingDescription.replace(regex, "$1");
    });

    remainingDescription = remainingDescription
      .replace(/,\s*,/g, ",")
      .replace(/^\s*,\s*/g, "")
      .replace(/\s*,\s*$/g, "")
      .replace(/^\s*\n/gm, "")
      .replace(/\n{2,}/g, "\n")
      .trim();

    return {
      designTypes: selectedTypes,
      customDescription: remainingDescription,
    };
  };
  const openDescriptionModal = (work) => {
    const { designTypes, extraDescription } = getWorkDescriptionData(
      work.description || "",
    );

    setSelectedDescription({
      description: extraDescription || "",
      height: work.height || "-",
      area: work.area || "-",
      color: work.color || "-",
      designType: designTypes || "-",
    });

    setShowDescriptionModal(true);
  };
  useEffect(() => {
    getWorks(true);
    getPayments();
    getCommission();

    const interval = setInterval(() => {
      getWorks(true);
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const getCommission = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}?action=get_platform_bid_commission`,
      );

      const result = await response.json();

      if (result.status) {
        setCommission(result.commission);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleRowStatusChange = async (work, newStatus) => {
    if (!newStatus || newStatus === work.status) return;

    const confirmChange = window.confirm(
      `Are you sure you want to change status from "${work.status}" to "${newStatus}"?`,
    );

    if (!confirmChange) return;

    try {
      // ==========================================
      // 1. UPDATE WORK REQUEST STATUS
      // ==========================================

      const formData = new FormData();
      formData.append("id", work.id);
      formData.append("status", newStatus);

      const response = await fetch(`${BASE_URL}?action=update_work_status`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (!result.status) {
        alert(result.message);
        return;
      }

      // ==========================================
      // 2. UPDATE ALL BIDS STATUS
      // ==========================================

      const bidFormData = new FormData();
      bidFormData.append("work_id", work.id);
      bidFormData.append("status", newStatus);

      const bidResponse = await fetch(
        `${BASE_URL}?action=sync_work_bid_status`,
        {
          method: "POST",
          body: bidFormData,
        },
      );

      const bidResult = await bidResponse.json();

      if (!bidResult.status) {
        alert(bidResult.message);
        return;
      }

      // ==========================================
      // 3. REFRESH WORKS + BIDS
      // ==========================================

      alert("Work and bid status updated successfully.");

      await getWorks();
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update status.");
    }
  };
  const updateCommission = async () => {
    try {
      const fd = new FormData();
      fd.append("commission", commission);

      const response = await fetch(
        `${BASE_URL}?action=update_platform_bid_commission`,
        {
          method: "POST",
          body: fd,
        },
      );

      const result = await response.json();

      alert(result.message);

      if (result.status) {
        getCommission();
      }
    } catch (err) {
      console.error(err);
    }
  };
  // --- FETCH PAYMENTS ---
  const getPayments = async () => {
    try {
      const response = await fetch(
        `${BASE_URL1}?action=get_all_designer_payments`,
      );
      const result = await response.json();
      if (result.status) {
        setPayments(result.data || []);
      }
    } catch (error) {
      console.error("Error fetching payment history:", error);
    }
  };

  // --- DELETE PAYMENT ---
  const deletePayment = async (paymentId) => {
    if (!window.confirm("Are you sure you want to delete this payment record?"))
      return;

    try {
      const fd = new FormData();
      fd.append("id", paymentId);

      const response = await fetch(
        `${BASE_URL1}?action=delete_designer_payment`,
        {
          method: "POST",
          body: fd,
        },
      );

      const result = await response.json();
      alert(result.message);

      if (result.status) {
        getPayments();
      }
    } catch (err) {
      console.error("Error deleting payment:", err);
      alert("Failed to delete payment.");
    }
  };

  // --- EDIT PAYMENT MODAL HANDLERS ---
  const openEditPaymentModal = (payment) => {
    setEditingPayment({ ...payment });
    setShowEditPaymentModal(true);
  };

  const handleUpdatePayment = async () => {
    if (!editingPayment) return;

    try {
      const fd = new FormData();
      fd.append("id", editingPayment.id);
      fd.append("amount", editingPayment.amount);
      fd.append("payment_mode", editingPayment.payment_mode);
      fd.append("transaction_no", editingPayment.transaction_no || "");
      fd.append("payment_date", editingPayment.payment_date);
      fd.append("remarks", editingPayment.remarks || "");

      const response = await fetch(
        `${BASE_URL1}?action=update_designer_payment`,
        {
          method: "POST",
          body: fd,
        },
      );

      const result = await response.json();
      alert(result.message);

      if (result.status) {
        setShowEditPaymentModal(false);
        setEditingPayment(null);
        getPayments();
      }
    } catch (err) {
      console.error("Error updating payment:", err);
      alert("Failed to update payment.");
    }
  };

  // Modal Lightbox Handlers
  const openPaymentModal = (work) => {
    if (!work.bids || !Array.isArray(work.bids) || work.bids.length === 0) {
      alert("No bids found for this work item.");
      return;
    }

    const acceptedBid = work.bids.find((b) =>
      ["accepted", "completed"].includes((b.status || "").toLowerCase()),
    );

    if (!acceptedBid) {
      alert("No accepted bid found to release payment for.");
      return;
    }

    setPaymentData({
      work_id: work.id,
      bid_id: acceptedBid.id,
      designer_id: acceptedBid.designer_id,
      amount: acceptedBid.received_amount || "",
      payment_mode: "Bank",
      transaction_no: "",
      payment_date: new Date().toISOString().split("T")[0],
      remarks: "",
    });

    setShowPaymentModal(true);
  };

  const releasePayment = async () => {
    try {
      const fd = new FormData();
      fd.append("work_id", paymentData.work_id);
      fd.append("bid_id", paymentData.bid_id);
      fd.append("designer_id", paymentData.designer_id);
      fd.append("amount", paymentData.amount);
      fd.append("payment_mode", paymentData.payment_mode);
      fd.append("transaction_no", paymentData.transaction_no);
      fd.append("payment_date", paymentData.payment_date);
      fd.append("remarks", paymentData.remarks);

      const response = await fetch(
        `${BASE_URL1}?action=release_designer_payment`,
        {
          method: "POST",
          body: fd,
        },
      );

      const result = await response.json();
      alert(result.message);

      if (result.status) {
        setShowPaymentModal(false);
        getWorks();
        getPayments(); // Refresh payment list
      }
    } catch (err) {
      console.error(err);
      alert("Payment release failed.");
    }
  };

  // Status Filter List for Works
  const STATUS_LIST = [
    "All",
    "Pending",
    "Active",
    "Accepted",
    "Start Work",
    "In Progress",
    "Work in Review",
    "Completed",
    "Paid",
  ];
  // =====================================================
  // HOVER IMAGE PREVIEW
  // =====================================================
  const handleImageHover = (e, imgSrc) => {
    const rect = e.currentTarget.getBoundingClientRect();

    const previewWidth = 310;
    const previewHeight = 310;
    const gap = 12;

    let left = rect.right + gap;
    let top = rect.top;

    // If there is no space on right, show on left
    if (left + previewWidth > window.innerWidth - 10) {
      left = rect.left - previewWidth - gap;
    }

    // Keep inside bottom
    if (top + previewHeight > window.innerHeight - 10) {
      top = window.innerHeight - previewHeight - 10;
    }

    // Keep inside top
    if (top < 10) {
      top = 10;
    }

    // Keep inside left
    if (left < 10) {
      left = 10;
    }

    setHoverPreview({
      image: imgSrc,
      left,
      top,
    });
  };

  const clearImageHover = () => {
    setHoverPreview({
      image: null,
      left: 0,
      top: 0,
    });
  };
  // Image Preview Controls
  const openPreview = (images, index, ownerId) => {
    const imageUrls = images.map((img) => `${UPLOAD_URL}/${ownerId}/${img}`);
    setPreviewData({ images: imageUrls, currentIndex: index });
  };

  const prevImage = () => {
    setPreviewData((prev) => ({
      ...prev,
      currentIndex:
        prev.currentIndex === 0
          ? prev.images.length - 1
          : prev.currentIndex - 1,
    }));
  };

  const nextImage = () => {
    setPreviewData((prev) => ({
      ...prev,
      currentIndex:
        prev.currentIndex === prev.images.length - 1
          ? 0
          : prev.currentIndex + 1,
    }));
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!previewData) return;
      if (e.key === "ArrowLeft") prevImage();
      else if (e.key === "ArrowRight") nextImage();
      else if (e.key === "Escape") setPreviewData(null);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [previewData]);

  // GET ALL WORKS
  const getWorks = async (showNotification = true) => {
    try {
      const response = await fetch(`${BASE_URL}?action=get_all_works`);
      const result = await response.json();

      if (!result.status) return;

      const newWorks = result.data || [];

      // Local storage key for admin
      const storageKey = "admin_work_bid_counts";

      const storedBidCounts = JSON.parse(
        localStorage.getItem(storageKey) || "{}",
      );

      const updatedBidCounts = {};
      const newlyUpdatedWorks = [];

      newWorks.forEach((work) => {
        const workId = String(work.id);

        const currentBids = Number(work.total_bids || 0);

        const previousBids =
          storedBidCounts[workId] !== undefined
            ? Number(storedBidCounts[workId])
            : 0;

        updatedBidCounts[workId] = currentBids;

        // Only notify if we already know this work
        // and its bid count increased.
        if (
          showNotification &&
          storedBidCounts[workId] !== undefined &&
          currentBids > previousBids
        ) {
          newlyUpdatedWorks.push({
            ...work,
            newBids: currentBids - previousBids,
          });
        }
      });

      const isFirstLoad = Object.keys(storedBidCounts).length === 0;

      if (!isFirstLoad && newlyUpdatedWorks.length > 0) {
        // Highlight rows
        setNewBidWorks((prev) => {
          const ids = new Set(prev);

          newlyUpdatedWorks.forEach((work) => {
            ids.add(String(work.id));
          });

          return Array.from(ids);
        });

        // Show all new works together
        setNewBidPopup(newlyUpdatedWorks);
      }

      // Save latest bid counts
      localStorage.setItem(storageKey, JSON.stringify(updatedBidCounts));

      setWorks(newWorks);
    } catch (error) {
      console.error("Error fetching works:", error);
    }
  };

  // CHANGE WORK STATUS
  const changeStatus = async (id, status) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("status", status);

    try {
      const response = await fetch(`${BASE_URL}?action=update_work_status`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      alert(result.message);

      if (result.status) {
        getWorks();
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  const getSubmittedDays = (submittedDate) => {
    if (!submittedDate) return "-";

    const submitted = new Date(submittedDate);
    const today = new Date();

    submitted.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffTime = today - submitted;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "1 Day";
    return `${diffDays} Days`;
  };
  // DOWNLOAD WORK FILES
  const downloadWork = async (workId) => {
    try {
      const response = await fetch(
        `${BASE_URL1}?action=get_work_delivery&work_id=${workId}`,
      );
      const result = await response.json();

      if (!result.status) {
        alert(result.message);
        return;
      }

      const files = result.data.design_files || [];
      if (files.length === 0) {
        alert("No files uploaded.");
        return;
      }

      files.forEach((file) => {
        window.open(
          `${API.BASE_URL}/download_work_file.php?work_id=${workId}&file=${encodeURIComponent(file)}`,
          "_blank",
        );
      });
    } catch (err) {
      console.error("Error downloading file:", err);
    }
  };

  // DELETE / REJECT WORK
  const rejectWork = async (id) => {
    if (!window.confirm("Are you sure you want to reject/delete this work?"))
      return;

    const formData = new FormData();
    formData.append("id", id);

    try {
      const response = await fetch(`${BASE_URL}?action=delete_work`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      alert(result.message);

      if (result.status) {
        getWorks();
      }
    } catch (error) {
      console.error("Error deleting work:", error);
    }
  };

  // WORK FILTERING
  const filteredWorks = works.filter((item) => {
    const matchesStatus =
      filter === "All" ||
      (item.status || "").toLowerCase() === filter.toLowerCase();

    let matchesDate = true;
    if (fromDate || toDate) {
      const itemDateStr = item.created_at || item.date;
      if (itemDateStr) {
        const itemDate = new Date(itemDateStr).setHours(0, 0, 0, 0);
        const start = fromDate ? new Date(fromDate).setHours(0, 0, 0, 0) : null;
        const end = toDate ? new Date(toDate).setHours(23, 59, 59, 999) : null;

        if (start && itemDate < start) matchesDate = false;
        if (end && itemDate > end) matchesDate = false;
      }
    }

    return matchesStatus && matchesDate;
  });
  // const dashboardStats = filteredWorks.reduce(
  //   (acc, item) => {
  //     const commission = item.commission_amount || "0";
  //     const designer = item.received_amount || "0";

  //     acc.totalWorks += 1;
  //     acc.platform += commission;
  //     acc.designer += designer;
  //     acc.total += commission + designer;

  //     return acc;
  //   },
  //   {
  //     totalWorks: 0,
  //     platform: 0,
  //     designer: 0,
  //     total: 0,
  //   },
  // );
  const addDecimalStrings = (a, b) => {
    const [aInt, aDec = ""] = String(a ?? "0").split(".");
    const [bInt, bDec = ""] = String(b ?? "0").split(".");

    const decimalLength = Math.max(aDec.length, bDec.length);

    const aNumber =
      parseInt(aInt || "0", 10) * Math.pow(10, decimalLength) +
      parseInt((aDec || "").padEnd(decimalLength, "0") || "0", 10);

    const bNumber =
      parseInt(bInt || "0", 10) * Math.pow(10, decimalLength) +
      parseInt((bDec || "").padEnd(decimalLength, "0") || "0", 10);

    const total = aNumber + bNumber;

    const divisor = Math.pow(10, decimalLength);
    const integerPart = Math.floor(total / divisor);
    const decimalPart = String(total % divisor).padStart(decimalLength, "0");

    return decimalLength > 0
      ? `${integerPart}.${decimalPart}`
      : `${integerPart}`;
  };

  const dashboardStats = filteredWorks.reduce(
    (acc, item) => {
      // Take values DIRECTLY from database
      const commission = item.commission_amount ?? "0";
      const designer = item.received_amount ?? "0";
      const acceptedPrice = item.accepted_price ?? "0";

      acc.totalWorks += 1;

      // Platform Earnings = SUM(commission_amount)
      acc.platform = addDecimalStrings(acc.platform, commission);

      // Designer Earnings = SUM(received_amount)
      acc.designer = addDecimalStrings(acc.designer, designer);

      // Total = SUM(accepted_price)
      acc.total = addDecimalStrings(acc.total, acceptedPrice);

      return acc;
    },
    {
      totalWorks: 0,
      platform: "0",
      designer: "0",
      total: "0",
    },
  );
  const renderStatusBadge = (status) => {
    const rawStatus = status || "Unknown";
    const statusClass = rawStatus.toLowerCase().replace(/\s+/g, "-");
    return (
      <span className={`vwk-badge vwk-badge-${statusClass}`}>{rawStatus}</span>
    );
  };

  const openBidModal = (work) => {
    setSelectedWork(work);
    setShowBidModal(true);
  };
  // Open Accepted Work Action Modal
  const openAcceptedActionModal = (work) => {
    setSelectedAcceptedWork(work);
    setShowAcceptedActionModal(true);
  };

  // Permanently Delete Work
  const permanentlyDeleteWork = async () => {
    if (!selectedAcceptedWork) return;

    const confirmDelete = window.confirm(
      "Are you sure you want to permanently delete this work?",
    );

    if (!confirmDelete) return;

    try {
      const formData = new FormData();

      formData.append("id", selectedAcceptedWork.id);

      // IMPORTANT: PHP needs owner_id to delete uploaded images
      formData.append("owner_id", selectedAcceptedWork.owner_id);

      formData.append("permanent_delete", "1");

      const response = await fetch(`${BASE_URL}?action=delete_work`, {
        method: "POST",
        body: formData,
      });

      const text = await response.text();

      console.log("Delete response:", text);

      let result;

      try {
        result = JSON.parse(text);
      } catch (e) {
        console.error("Invalid JSON response:", text);
        alert("Work was deleted, but server returned an invalid response.");
        return;
      }

      alert(result.message);

      if (result.status) {
        setShowAcceptedActionModal(false);
        setSelectedAcceptedWork(null);

        await getWorks();
      }
    } catch (error) {
      console.error("Permanent delete error:", error);
      alert("Failed to permanently delete work.");
    }
  };
  // Reactivate Work
  const reactivateWork = async () => {
    if (!selectedAcceptedWork) return;

    const confirmReactivate = window.confirm(
      "Are you sure you want to reactivate this work?\n\nThe accepted bid and payment details will be reset.",
    );

    if (!confirmReactivate) return;

    try {
      const formData = new FormData();

      formData.append("id", selectedAcceptedWork.id);
      formData.append("status", "Active");
      formData.append("reactivate", "1");

      const response = await fetch(`${BASE_URL}?action=update_work_status1`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      alert(result.message);

      if (result.status) {
        setShowAcceptedActionModal(false);
        setSelectedAcceptedWork(null);

        getWorks();
      }
    } catch (error) {
      console.error("Reactivate error:", error);
      alert("Failed to reactivate work.");
    }
  };
  const DESIGN_TYPES = ["Multi", "Sequence", "Cording", "Beads"];

  const getWorkDescriptionData = (description = "") => {
    if (!description) {
      return {
        designTypes: "",
        extraDescription: "",
      };
    }

    // Split description by comma or new line
    const parts = description
      .split(/,|\n/)
      .map((item) => item.trim())
      .filter(Boolean);

    const selectedTypes = [];
    const extraParts = [];

    parts.forEach((part) => {
      const matchedType = DESIGN_TYPES.find(
        (type) => type.toLowerCase() === part.toLowerCase(),
      );

      if (matchedType) {
        selectedTypes.push(matchedType);
      } else {
        extraParts.push(part);
      }
    });

    return {
      designTypes: selectedTypes.join(", "),
      extraDescription: extraParts.join(", "),
    };
  };
  return (
    <div className="vwk-main-container">
      {/* Header Section */}
      {/* <div className="vwk-page-header">
        <div>
          <h2 className="vwk-page-title">Work & Payment Management</h2>
          <p className="vwk-page-subtitle">
            Manage work request workflows and track designer payment
            transactions.
          </p>
        </div>
      </div> */}
      <div className="vwk-page-header">
        <div>
          <h2 className="vwk-page-title">Work & Payment Management</h2>
          <p className="vwk-page-subtitle">
            Manage work request workflows and track designer payments.
          </p>
        </div>

        <div className="vwk-commission-box">
          <label>Platform Commission (%)</label>

          <input
            type="number"
            value={commission}
            onChange={(e) => setCommission(e.target.value)}
            className="vwk-commission-input"
          />

          <button className="vwk-commission-btn" onClick={updateCommission}>
            Save
          </button>
        </div>
      </div>
      {/* <div className="vwk-card mb-3">
        <div className="vwk-card-header">
          <h3 className="vwk-card-title">
            <i className="bi bi-percent me-2"></i>
            Platform Bid Commission
          </h3>
        </div>

        <div
          style={{
            display: "flex",
            gap: "15px",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <div>
            <label>Commission (%)</label>

            <input
              type="number"
              step="0.01"
              className="form-control"
              value={commission}
              onChange={(e) => setCommission(e.target.value)}
              style={{ width: "180px" }}
            />
          </div>

          <button className="btn btn-primary mt-4" onClick={updateCommission}>
            <i className="bi bi-save me-2"></i>
            Save
          </button>
        </div>
      </div> */}
      {/* Main Top Navigation Tabs */}
      <div
        className="vwk-card vwk-filter-card"
        style={{ marginBottom: "15px" }}
      >
        <div className="vwk-filter-tabs">
          <button
            className={`vwk-tab-btn ${activeTab === "works" ? "active" : ""}`}
            onClick={() => setActiveTab("works")}
          >
            <i className="bi bi-briefcase me-2"></i> Work Requests
          </button>
          <button
            className={`vwk-tab-btn ${activeTab === "payments" ? "active" : ""}`}
            onClick={() => setActiveTab("payments")}
          >
            <i className="bi bi-cash-stack me-2"></i> Payment History
          </button>
        </div>
      </div>

      {/* ================= SECTION 1: WORK REQUESTS TAB ================= */}
      {activeTab === "works" && (
        <>
          {/* Status Toolbar */}
          <div className="vwk-card vwk-filter-card">
            <div className="vwk-toolbar-row">
              <div className="vwk-status-filter-tabs">
                {STATUS_LIST.map((st) => {
                  const statusClass = st
                    .toLowerCase()
                    .trim()
                    .replace(/\s+/g, "-");

                  return (
                    <button
                      key={st}
                      type="button"
                      className={`vwk-status-filter-btn vwk-status-${statusClass} ${
                        filter === st ? "active" : ""
                      }`}
                      onClick={() => setFilter(st)}
                    >
                      {st}
                    </button>
                  );
                })}
              </div>

              <div className="vwk-date-picker-wrap">
                <DateFilter
                  fromDate={fromDate}
                  toDate={toDate}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                />
              </div>
            </div>
          </div>
          <div className="row g-3 mb-4">
            <div className="col-md-3">
              <div className="card shadow-sm border-0 h-100">
                <div className="card-body text-center">
                  <h6 className="text-muted">Total Works</h6>
                  <h2>{dashboardStats.totalWorks}</h2>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="card shadow-sm border-0 h-100">
                <div className="card-body text-center">
                  <h6 className="text-muted">Platform Earnings</h6>
                  <h2 className="text-success">₹ {dashboardStats.platform}</h2>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="card shadow-sm border-0 h-100">
                <div className="card-body text-center">
                  <h6 className="text-muted">Designer Earnings</h6>
                  <h2 className="text-primary">₹ {dashboardStats.designer}</h2>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="card shadow-sm border-0 h-100">
                <div className="card-body text-center">
                  <h6 className="text-muted">Total</h6>
                  <h2 className="text-danger">₹ {dashboardStats.total}</h2>
                </div>
              </div>
            </div>
          </div>
          {/* Works Table */}
          <section className="vwk-card">
            <div className="vwk-card-header">
              <h3 className="vwk-card-title">Submissions List ({filter})</h3>
              <span className="vwk-count-pill">
                {filteredWorks.length}{" "}
                {filteredWorks.length === 1 ? "Item" : "Items"}
              </span>
            </div>

            <div className="vwk-table-responsive">
              <table className="vwk-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>User</th>
                    <th>Images</th>
                    {/* <th style={{ width: "180px" }}>Details</th> */}

                    {/* <th style={{ width: "180px" }}>Design Type</th> */}

                    <th>Description</th>

                    <th>Bid Price</th>

                    <th>Commission</th>

                    <th>d_Earnings</th>
                    <th>Status</th>
                    <th>Submitted Date</th>
                    <th>Days</th>
                    <th>Rating</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredWorks.length > 0 ? (
                    filteredWorks.map((item, index) => (
                      <tr
                        key={item.id}
                        className={
                          newBidWorks.includes(String(item.id))
                            ? "vwk-new-bid-row"
                            : ""
                        }
                      >
                        <td className="vwk-col-index">
                          {filteredWorks.length - index}
                        </td>
                        <td>
                          <span className="vwk-date-text">
                            {item.created_at || item.date
                              ? new Date(
                                  item.created_at || item.date,
                                ).toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "2-digit",
                                })
                              : ""}
                          </span>
                        </td>
                        <td>
                          <strong className="vwk-user-name">{item.name}</strong>
                          <br />
                          <small className="vwk-user-phone">{item.phone}</small>
                        </td>
                        <td>
                          <div className="vwk-thumbs-grid">
                            {item.images?.map((img, i) => {
                              const imgSrc = `${UPLOAD_URL}/${item.owner_id}/${img}`;
                              return (
                                <div
                                  key={i}
                                  className="vwk-thumb-item"
                                  onClick={() =>
                                    openPreview(item.images, i, item.owner_id)
                                  }
                                  title="Click to zoom image"
                                >
                                  <img
                                    src={imgSrc}
                                    alt="Work Upload"
                                    className="vwk-table-thumb"
                                    onMouseEnter={(e) =>
                                      handleImageHover(e, imgSrc)
                                    }
                                    onMouseLeave={clearImageHover}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </td>
                        {/* <td>
                          <div>
                            <small>
                              <strong>H:</strong> {item.height || ""}
                            </small>
                            <br />
                            <small>
                              <strong>Area:</strong> {item.area || ""}
                            </small>
                            <br />
                            <small>
                              <strong>Color:</strong> {item.color || ""}
                            </small>
                          </div>
                        </td>
                        <td>
                          {(() => {
                            const { designTypes } = getWorkDescriptionData(
                              item.description,
                            );

                            return designTypes || "-";
                          })()}
                        </td> */}

                        <td>
                          {(() => {
                            const { extraDescription } = getWorkDescriptionData(
                              item.description || "",
                            );

                            return (
                              <p
                                className="vwk-table-desc-text"
                                style={{
                                  cursor: "pointer",
                                  marginBottom: 0,
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openDescriptionModal(item);
                                }}
                                title="Click to view full description"
                              >
                                {extraDescription?.length > 120
                                  ? `${extraDescription.substring(0, 120)}...`
                                  : extraDescription || "-"}
                              </p>
                            );
                          })()}
                        </td>
                        <td>{item.accepted_price || "-"}</td>
                        <td>
                          {item.commission_amount ? (
                            <>
                              ₹{item.commission_amount}
                              <br />
                              <small className="text-muted">
                                ({item.commission_ratio}%)
                              </small>
                            </>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>{item.received_amount || "-"}</td>
                        {/* <td>{renderStatusBadge(item.status)}</td> */}
                        {/* <td>
                          <select
                            className="vwk-status-select"
                            value={item.status || ""}
                            onChange={(e) =>
                              handleRowStatusChange(item, e.target.value)
                            }
                          >
                            {STATUS_LIST.filter(
                              (status) => status !== "All",
                            ).map((status) => (
                              <option key={status} value={status}>
                                {status}
                              </option>
                            ))}
                          </select>
                        </td> */}
                        <td>
                          <select
                            className="vwk-status-select"
                            value={item.status || ""}
                            onChange={(e) =>
                              handleRowStatusChange(item, e.target.value)
                            }
                          >
                            {STATUS_LIST.filter(
                              (status) => status !== "All",
                            ).map((status) => (
                              <option key={status} value={status}>
                                {status}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td>
                          {item.delivered_date ? (
                            <>
                              {new Date(item.delivered_date).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "2-digit",
                                },
                              )}
                              <br />
                              <small>
                                {new Date(
                                  item.delivered_date,
                                ).toLocaleTimeString("en-GB", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </small>
                            </>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>{getSubmittedDays(item.delivered_date)}</td>
                        <td>
                          {item.rating && Number(item.rating) > 0 ? (
                            <div className="vwk-work-rating">
                              {[1, 2, 3, 4, 5].map((star) => (
                                <i
                                  key={star}
                                  className={
                                    star <= Number(item.rating)
                                      ? "bi bi-star-fill"
                                      : "bi bi-star"
                                  }
                                ></i>
                              ))}

                              <span>{Number(item.rating).toFixed(1)}</span>
                            </div>
                          ) : (
                            <span className="vwk-rating-not-rated">
                              Not Rated
                            </span>
                          )}
                        </td>
                        {/* <td>
                          <select
                            className="vwk-status-select"
                            value={item.status || ""}
                            onChange={(e) =>
                              handleRowStatusChange(item, e.target.value)
                            }
                          >
                            {STATUS_LIST.filter(
                              (status) =>
                                !["All", "Pending", "Active"].includes(status),
                            ).map((status) => (
                              <option key={status} value={status}>
                                {status}
                              </option>
                            ))}
                          </select>
                        </td> */}

                        <td style={{ textAlign: "right" }}>
                          <div className="vwk-action-btns">
                            <button
                              type="button"
                              className="vwk-btn-icon vwk-btn-edit"
                              onClick={() => openEditWorkModal(item)}
                              title="Edit Work"
                            >
                              <i className="bi bi-pencil-square"></i>
                            </button>
                            {item.status === "Pending" ? (
                              <>
                                <button
                                  className="vwk-btn-icon vwk-btn-approve"
                                  onClick={() =>
                                    changeStatus(item.id, "Active")
                                  }
                                  title="Approve Request"
                                >
                                  <i className="bi bi-check-lg"></i>
                                </button>
                                <button
                                  className="vwk-btn-icon vwk-btn-reject"
                                  onClick={() => rejectWork(item.id)}
                                  title="Reject Request"
                                >
                                  <i className="bi bi-x-lg"></i>
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  className={`eb-awp-act-btn eb-awp-act-bids
    ${
      String(item.status).toLowerCase() === "active" &&
      Number(item.total_bids) > 0
        ? "eb-awp-has-bids eb-awp-new-bid-highlight"
        : ""
    }
  `}
                                  onClick={() => {
                                    openBidModal(item);

                                    setNewBidWorks((prev) =>
                                      prev.filter(
                                        (id) => id !== String(item.id),
                                      ),
                                    );

                                    setNewBidPopup((prev) =>
                                      prev.filter(
                                        (work) =>
                                          String(work.id) !== String(item.id),
                                      ),
                                    );
                                  }}
                                  title="View Bids"
                                >
                                  <i className="bi bi-people-fill me-1"></i>(
                                  {item.total_bids || 0})
                                </button>

                                {/* ACCEPTED WORK ACTION */}
                                {String(item.status || "")
                                  .trim()
                                  .toLowerCase() === "accepted" && (
                                  <button
                                    className="vwk-btn-icon vwk-btn-reject"
                                    onClick={() =>
                                      openAcceptedActionModal(item)
                                    }
                                    title="Delete or Reactivate Work"
                                  >
                                    <i className="bi bi-trash"></i>
                                  </button>
                                )}

                                {(item.status === "Work in Review" ||
                                  item.status === "Completed") && (
                                  <button
                                    className="vwk-btn-download"
                                    onClick={() => downloadWork(item.id)}
                                    title="Download Completed Work"
                                  >
                                    <i className="bi bi-download"></i>
                                  </button>
                                )}

                                {item.status === "Completed" && (
                                  <button
                                    className="vwk-btn-payment"
                                    onClick={() => openPaymentModal(item)}
                                  >
                                    <i className="bi bi-cash-coin"></i>
                                    Pay
                                  </button>
                                )}
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="13" className="vwk-empty-cell">
                        <i className="bi bi-folder-x vwk-empty-icon"></i>
                        <p>No work items match your selected filter.</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>
        </>
      )}

      {/* ================= SECTION 2: PAYMENT HISTORY TAB ================= */}
      {activeTab === "payments" && (
        <section className="vwk-card">
          <div className="vwk-card-header">
            <h3 className="vwk-card-title">Designer Payment Records</h3>
            <span className="vwk-count-pill">{payments.length} Payments</span>
          </div>

          <div className="vwk-table-responsive">
            <table className="vwk-table">
              <thead>
                <tr>
                  <th style={{ width: "50px" }}>#</th>
                  <th>Date</th>
                  <th>Designer</th>
                  <th>Work Details</th>
                  <th>Amount (₹)</th>
                  <th>Mode</th>
                  <th>Transaction No</th>
                  <th>Remarks</th>
                  <th style={{ textAlign: "right", width: "120px" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {payments.length > 0 ? (
                  payments.map((p, index) => (
                    <tr key={p.id}>
                      <td className="vwk-col-index">
                        {payments.length - index}
                      </td>
                      <td>
                        {p.payment_date
                          ? new Date(p.payment_date).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              },
                            )
                          : "-"}
                      </td>
                      <td>
                        <strong>
                          {p.designer_name || `Designer #${p.designer_id}`}
                        </strong>
                      </td>
                      <td>
                        <small>
                          {p.work_description || `Work ID: #${p.work_id}`}
                        </small>
                      </td>
                      <td>
                        <strong>₹ {Number(p.amount).toLocaleString()}</strong>
                      </td>
                      <td>
                        <span className="vwk-badge vwk-badge-accepted">
                          {p.payment_mode}
                        </span>
                      </td>
                      <td>{p.transaction_no || "-"}</td>
                      <td>{p.remarks || "-"}</td>
                      <td style={{ textAlign: "right" }}>
                        <div className="vwk-action-btns">
                          <button
                            className="vwk-btn-icon vwk-btn-approve"
                            onClick={() => openEditPaymentModal(p)}
                            title="Edit Payment"
                          >
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button
                            className="vwk-btn-icon vwk-btn-reject"
                            onClick={() => deletePayment(p.id)}
                            title="Delete Payment"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="vwk-empty-cell">
                      <i className="bi bi-cash-stack vwk-empty-icon"></i>
                      <p>No payment records found.</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      )}

      {/* Edit Payment Modal */}
      {showEditPaymentModal && editingPayment && (
        <div className="vwk-pm-overlay">
          <div className="vwk-pm-modal">
            <div className="vwk-pm-header">
              <h4>Edit Designer Payment</h4>
              <button
                className="vwk-pm-close-btn"
                onClick={() => setShowEditPaymentModal(false)}
              >
                &times;
              </button>
            </div>

            <div className="vwk-pm-body">
              <div className="vwk-pm-form-group">
                <label>Amount (₹)</label>
                <input
                  type="number"
                  className="vwk-pm-input"
                  value={editingPayment.amount}
                  onChange={(e) =>
                    setEditingPayment({
                      ...editingPayment,
                      amount: e.target.value,
                    })
                  }
                />
              </div>

              <div className="vwk-pm-form-group">
                <label>Payment Mode</label>
                <select
                  className="vwk-pm-select"
                  value={editingPayment.payment_mode}
                  onChange={(e) =>
                    setEditingPayment({
                      ...editingPayment,
                      payment_mode: e.target.value,
                    })
                  }
                >
                  <option value="Bank">Bank</option>
                  <option value="UPI">UPI</option>
                  <option value="Cash">Cash</option>
                  <option value="Cheque">Cheque</option>
                </select>
              </div>

              <div className="vwk-pm-form-group">
                <label>Transaction No.</label>
                <input
                  type="text"
                  className="vwk-pm-input"
                  value={editingPayment.transaction_no || ""}
                  onChange={(e) =>
                    setEditingPayment({
                      ...editingPayment,
                      transaction_no: e.target.value,
                    })
                  }
                />
              </div>

              <div className="vwk-pm-form-group">
                <label>Date</label>
                <input
                  type="date"
                  className="vwk-pm-input"
                  value={editingPayment.payment_date || ""}
                  onChange={(e) =>
                    setEditingPayment({
                      ...editingPayment,
                      payment_date: e.target.value,
                    })
                  }
                />
              </div>

              <div className="vwk-pm-form-group">
                <label>Remarks</label>
                <textarea
                  className="vwk-pm-textarea"
                  rows="3"
                  value={editingPayment.remarks || ""}
                  onChange={(e) =>
                    setEditingPayment({
                      ...editingPayment,
                      remarks: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div className="vwk-pm-footer">
              <button
                className="vwk-pm-btn vwk-pm-btn-cancel"
                onClick={() => setShowEditPaymentModal(false)}
              >
                Cancel
              </button>
              <button
                className="vwk-pm-btn vwk-pm-btn-submit"
                onClick={handleUpdatePayment}
              >
                Update Payment
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Original Payment Release Modal */}
      {showPaymentModal && (
        <div className="vwk-pm-overlay">
          <div className="vwk-pm-modal">
            <div className="vwk-pm-header">
              <h4>Release Designer Payment</h4>
              <button
                className="vwk-pm-close-btn"
                onClick={() => setShowPaymentModal(false)}
              >
                &times;
              </button>
            </div>

            <div className="vwk-pm-body">
              <div className="vwk-pm-form-group">
                <label>Amount (₹)</label>
                <input
                  type="number"
                  className="vwk-pm-input"
                  value={paymentData.amount}
                  onChange={(e) =>
                    setPaymentData({ ...paymentData, amount: e.target.value })
                  }
                />
              </div>

              <div className="vwk-pm-form-group">
                <label>Payment Mode</label>
                <select
                  className="vwk-pm-select"
                  value={paymentData.payment_mode}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      payment_mode: e.target.value,
                    })
                  }
                >
                  <option value="Bank">Bank</option>
                  <option value="UPI">UPI</option>
                  <option value="Cash">Cash</option>
                  <option value="Cheque">Cheque</option>
                </select>
              </div>

              <div className="vwk-pm-form-group">
                <label>Transaction No.</label>
                <input
                  type="text"
                  className="vwk-pm-input"
                  value={paymentData.transaction_no}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      transaction_no: e.target.value,
                    })
                  }
                />
              </div>

              <div className="vwk-pm-form-group">
                <label>Date</label>
                <input
                  type="date"
                  className="vwk-pm-input"
                  value={paymentData.payment_date}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      payment_date: e.target.value,
                    })
                  }
                />
              </div>

              <div className="vwk-pm-form-group">
                <label>Remarks</label>
                <textarea
                  className="vwk-pm-textarea"
                  rows="3"
                  value={paymentData.remarks}
                  onChange={(e) =>
                    setPaymentData({ ...paymentData, remarks: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="vwk-pm-footer">
              <button
                className="vwk-pm-btn vwk-pm-btn-cancel"
                onClick={() => setShowPaymentModal(false)}
              >
                Cancel
              </button>
              <button
                className="vwk-pm-btn vwk-pm-btn-submit"
                onClick={releasePayment}
              >
                Release Payment
              </button>
            </div>
          </div>
        </div>
      )}
      {showBidModal && selectedWork && (
        <div className="vwk-modal-overlay">
          <div className="vwk-bid-modal">
            <div className="vwk-bm-header">
              <div>
                <h3 className="vwk-bm-title">
                  <i className="bi bi-people-fill me-2"></i>
                  Bid Details
                </h3>
                <p className="vwk-bm-subtitle">
                  Total Bidders:{" "}
                  <span className="vwk-bm-count">
                    {selectedWork.total_bids || 0}
                  </span>
                </p>
              </div>

              <button
                className="vwk-bm-close"
                onClick={() => setShowBidModal(false)}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            <div className="vwk-bm-body">
              {!selectedWork.bids || selectedWork.bids.length === 0 ? (
                <div className="vwk-bm-empty">
                  <i className="bi bi-person-x-fill"></i>
                  <h4>No Bids Received</h4>
                  <p>No designer has submitted a quotation yet.</p>
                </div>
              ) : (
                <div className="vwk-table-responsive">
                  <table className="vwk-table vwk-bm-table">
                    <thead>
                      <tr>
                        <th style={{ width: "130px" }}>Date</th>
                        <th style={{ width: "70px" }}>Photo</th>
                        <th>Designer</th>
                        <th style={{ width: "130px" }}>Phone</th>
                        <th style={{ width: "120px" }}>Bid Price</th>
                        <th>Rating</th>
                        <th>Total Completed Work </th>
                        <th style={{ width: "120px" }}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedWork.bids.map((bid) => (
                        <tr key={bid.id}>
                          <td>
                            {new Date(bid.created_at).toLocaleDateString(
                              "en-GB",
                            )}
                          </td>
                          <td>
                            {bid.profile_image ? (
                              <img
                                src={`${API.BASE_URL}/uploads/profile/${bid.profile_image}`}
                                alt={bid.name}
                                onClick={() =>
                                  setProfilePreview(
                                    `${API.BASE_URL}/uploads/profile/${bid.profile_image}`,
                                  )
                                }
                                onError={(e) => {
                                  e.target.style.display = "none";
                                  e.target.nextSibling.style.display =
                                    "inline-flex";
                                }}
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  cursor: "pointer",
                                }}
                              />
                            ) : null}
                            {/* <img
                              src={
                                bid.profile_image
                                  ? `${API.BASE_URL}/uploads/profile/${bid.profile_image}`
                                  : "/images/user.png"
                              }
                              alt="Designer Profile"
                              className="vwk-bm-avatar"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setProfilePreview(
                                  bid.profile_image
                                    ? `${API.BASE_URL}/uploads/profile/${bid.profile_image}`
                                    : "/images/user.png",
                                )
                              }
                            /> */}
                            <div
                              style={{
                                display: bid.profile_image
                                  ? "none"
                                  : "inline-flex",
                                width: "45px",
                                height: "45px",
                                borderRadius: "50%",
                                background: "#f5f5f5",
                                border: "1px solid #ddd",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="bi bi-person-fill"
                                style={{
                                  fontSize: "22px",
                                  color: "#6c757d",
                                }}
                              ></i>
                            </div>
                          </td>
                          <td>
                            <div className="vwk-bm-user">
                              <strong>{bid.name}</strong>
                              <small>ID: {bid.designer_id}</small>
                            </div>
                          </td>
                          <td>{bid.phone}</td>
                          <td>
                            <span className="vwk-bm-price">
                              ₹ {Number(bid.price).toLocaleString()}
                            </span>
                          </td>

                          <td>
                            <RatingStars
                              rating={bid.rating}
                              ratingCount={bid.rating_count}
                              totalStars={bid.total_stars}
                            />
                          </td>
                          <td className="text-center">
                            <strong>{Number(bid.rating_count || 0)}</strong>
                          </td>
                          <td>
                            <span
                              className={`vwk-bid-status-badge vwk-bid-status-${(
                                bid.status || "neutral"
                              )
                                .toLowerCase()
                                .trim()
                                .replace(/\s+/g, "-")}`}
                            >
                              {bid.status || "Unknown"}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="vwk-bm-footer">
              <button
                className="vwk-bm-btn-close"
                onClick={() => setShowBidModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {/* =====================================================
    SIDE IMAGE HOVER PREVIEW
===================================================== */}
      {hoverPreview.image && (
        <div
          className="eb-awp-hover-preview"
          style={{
            left: `${hoverPreview.left}px`,
            top: `${hoverPreview.top}px`,
          }}
        >
          <img src={hoverPreview.image} alt="Large preview" />
        </div>
      )}
      {/* Lightbox Image Preview Modal */}
      {previewData && (
        <div
          className="vwk-lightbox-overlay"
          onClick={() => setPreviewData(null)}
        >
          <div
            className="vwk-lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="vwk-lightbox-close"
              onClick={() => setPreviewData(null)}
            >
              &times;
            </button>

            <img
              src={previewData.images[previewData.currentIndex]}
              alt="Preview"
              className="vwk-lightbox-img"
            />

            {previewData.images.length > 1 && (
              <>
                <button
                  className="vwk-lightbox-arrow vwk-lightbox-prev"
                  onClick={prevImage}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>

                <button
                  className="vwk-lightbox-arrow vwk-lightbox-next"
                  onClick={nextImage}
                >
                  <i className="bi bi-chevron-right"></i>
                </button>

                <div className="vwk-lightbox-counter">
                  {previewData.currentIndex + 1} / {previewData.images.length}
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {showDescriptionModal && (
        <div
          className="vwk-pm-overlay"
          onClick={() => setShowDescriptionModal(false)}
        >
          <div
            className="vwk-pm-modal vwk-description-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="vwk-pm-header">
              <h4>
                <i className="bi bi-info-circle me-2"></i>
                Work Details
              </h4>

              <button
                className="vwk-pm-close-btn"
                onClick={() => setShowDescriptionModal(false)}
              >
                &times;
              </button>
            </div>

            {/* BODY */}
            <div className="vwk-pm-body">
              <div className="eb-work-description-section">
                <div className="eb-design-type-list">
                  {selectedDescription.designType &&
                  selectedDescription.designType !== "-" ? (
                    selectedDescription.designType
                      .split(",")
                      .map((type) => type.trim())
                      .filter(Boolean)
                      .map((type) => (
                        <span
                          key={type}
                          className={`eb-design-type-badge eb-design-type-${type
                            .toLowerCase()
                            .replace(/\s/g, "")}`}
                        >
                          <i className="bi bi-check-circle-fill"></i>
                          {type}
                        </span>
                      ))
                  ) : (
                    <p className="eb-info-desc">No design type selected.</p>
                  )}
                </div>
              </div>
              {/* HEIGHT / AREA / COLOR */}
              <div className="vwk-description-info-row">
                <div className="vwk-description-info-box">
                  <span className="vwk-description-info-label">
                    <i className="bi bi-arrows-vertical"></i>
                    Height
                  </span>

                  <strong>{selectedDescription.height || "-"} mm</strong>
                </div>

                <div className="vwk-description-info-box">
                  <span className="vwk-description-info-label">
                    <i className="bi bi-bounding-box"></i>
                    Area
                  </span>

                  <strong>{selectedDescription.area || "-"} mm</strong>
                </div>

                <div className="vwk-description-info-box">
                  <span className="vwk-description-info-label">
                    <i className="bi bi-palette"></i>
                    Color
                  </span>

                  <strong>{selectedDescription.color || "-"}</strong>
                </div>
              </div>

              {/* FULL DESCRIPTION */}
              <div className="vwk-full-description-box">
                <div className="vwk-full-description-title">
                  <i className="bi bi-file-text"></i>
                  Description
                </div>

                <p>
                  {selectedDescription.description ||
                    "No description available."}
                </p>
              </div>
            </div>

            {/* FOOTER */}
            <div className="vwk-pm-footer">
              <button
                className="vwk-pm-btn vwk-pm-btn-cancel"
                onClick={() => setShowDescriptionModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {profilePreview && (
        <div
          className="vwk-lightbox-overlay"
          onClick={() => setProfilePreview(null)}
        >
          <div
            className="vwk-lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="vwk-lightbox-close"
              onClick={() => setProfilePreview(null)}
            >
              &times;
            </button>

            <img
              src={profilePreview}
              alt="Designer"
              className="vwk-lightbox-img"
            />
          </div>
        </div>
      )}
      {/* =====================================================
    NEW BID NOTIFICATION POPUP
===================================================== */}
      {newBidPopup.length > 0 && (
        <div>
          {/* <div className="vwk-new-bid-popup">
           
            <div className="vwk-new-bid-popup-header">
              <div className="vwk-new-bid-popup-heading">
                <div className="vwk-new-bid-popup-icon">
                  <i className="bi bi-bell-fill"></i>
                </div>

                <div>
                  <h3>New Bids Received</h3>
                  <p>New designer bids are available on your work.</p>
                </div>
              </div>

              <button
                className="vwk-new-bid-popup-close"
                onClick={() => setNewBidPopup([])}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

           
            <div className="vwk-new-bid-work-list">
              {newBidPopup.map((work) => {
                const workImage =
                  work.images &&
                  Array.isArray(work.images) &&
                  work.images.length > 0
                    ? `${UPLOAD_URL}/${work.owner_id}/${work.images[0]}`
                    : null;

                return (
                  <div key={work.id} className="vwk-new-bid-work-card">
                
                    <div className="vwk-new-bid-work-image">
                      {workImage ? (
                        <img src={workImage} alt={`Work ${work.id}`} />
                      ) : (
                        <div className="vwk-new-bid-no-image">
                          <i className="bi bi-image"></i>
                          <span>No Image</span>
                        </div>
                      )}
                    </div>

                    <div className="vwk-new-bid-work-content">
                      <div className="vwk-new-bid-work-title">
                        Work #{work.id}
                      </div>

                      <p className="vwk-new-bid-work-description">
                        {work.description || "No description available."}
                      </p>

                      <div className="vwk-new-bid-work-meta">
                        <span className="vwk-new-bid-new-count">
                          <i className="bi bi-person-plus-fill"></i>
                          {work.newBids} New
                        </span>

                        <span className="vwk-new-bid-total-count">
                          <i className="bi bi-people-fill"></i>
                          {work.total_bids || 0} Total
                        </span>
                      </div>

                      <button
                        className="vwk-new-bid-view-btn"
                        onClick={() => {
                          openBidModal(work);

                          setNewBidWorks((prev) =>
                            prev.filter((id) => id !== String(work.id)),
                          );

                          setNewBidPopup((prev) =>
                            prev.filter(
                              (item) => String(item.id) !== String(work.id),
                            ),
                          );
                        }}
                      >
                        <i className="bi bi-people-fill"></i>
                        View Bidders
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

        
            <div className="vwk-new-bid-popup-footer">
              <button
                className="vwk-new-bid-popup-btn"
                onClick={() => setNewBidPopup([])}
              >
                <i className="bi bi-check2"></i>
                Got It
              </button>
            </div>
          </div> */}
        </div>
      )}
      {showAcceptedActionModal && selectedAcceptedWork && (
        <div
          className="vwk-action-overlay"
          onClick={() => {
            setShowAcceptedActionModal(false);
            setSelectedAcceptedWork(null);
          }}
        >
          <div
            className="vwk-action-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="vwk-action-header">
              <div className="vwk-action-title">
                <div className="vwk-action-icon">
                  <i className="bi bi-exclamation-triangle-fill"></i>
                </div>

                <div>
                  <h4>Work Action</h4>
                  <span>Manage this accepted work</span>
                </div>
              </div>

              <button
                className="vwk-action-close"
                onClick={() => {
                  setShowAcceptedActionModal(false);
                  setSelectedAcceptedWork(null);
                }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            {/* BODY */}
            <div className="vwk-action-body">
              <p className="vwk-action-question">
                What would you like to do with this accepted work?
              </p>

              {/* WORK INFO */}
              {/* <div className="vwk-action-work-info">
                <div className="vwk-work-info-icon">
                  <i className="bi bi-briefcase-fill"></i>
                </div>

                <div className="vwk-work-info-content">
                  <span>Work ID</span>
                  <strong>{selectedAcceptedWork.id}</strong>

                  <p>
                    {selectedAcceptedWork.description ||
                      "No description available"}
                  </p>
                </div>
              </div> */}

              {/* ACTIONS */}
              <div className="vwk-action-options">
                {/* REACTIVATE */}
                <button
                  className="vwk-action-option vwk-reactivate"
                  onClick={reactivateWork}
                >
                  <div className="vwk-option-icon">
                    <i className="bi bi-arrow-repeat"></i>
                  </div>

                  <div className="vwk-option-content">
                    <strong>Reactivate </strong>
                  </div>

                  <i className="bi bi-chevron-right vwk-option-arrow"></i>
                </button>

                {/* DELETE */}
                <button
                  className="vwk-action-option vwk-delete"
                  onClick={permanentlyDeleteWork}
                >
                  <div className="vwk-option-icon">
                    <i className="bi bi-trash-fill"></i>
                  </div>

                  <div className="vwk-option-content">
                    <strong> Delete</strong>
                  </div>

                  <i className="bi bi-chevron-right vwk-option-arrow"></i>
                </button>
              </div>

              {/* WARNING */}
              <div className="vwk-action-warning">
                <i className="bi bi-info-circle-fill"></i>

                <span>
                  Permanent deletion cannot be undone. Please make sure you
                  really want to delete this work.
                </span>
              </div>
            </div>

            {/* FOOTER */}
            <div className="vwk-action-footer">
              <button
                className="vwk-action-cancel"
                onClick={() => {
                  setShowAcceptedActionModal(false);
                  setSelectedAcceptedWork(null);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {showEditWorkModal && editingWork && (
        <div className="vwk-pm-overlay">
          <div className="vwk-pm-modal vwk-edit-work-modal">
            {/* HEADER */}
            <div className="vwk-pm-header">
              <div>
                <h4>Edit Work Request</h4>
                <small>Work #{editingWork.id}</small>
              </div>

              <button
                type="button"
                className="vwk-pm-close-btn"
                onClick={() => {
                  setShowEditWorkModal(false);
                  setEditingWork(null);
                }}
              >
                &times;
              </button>
            </div>

            {/* BODY */}
            <div className="vwk-pm-body">
              {/* DESCRIPTION */}
              <div className="vwk-pm-form-group">
                <label>Description</label>

                <textarea
                  className="vwk-pm-textarea"
                  rows="5"
                  value={editWorkData.description}
                  onChange={(e) =>
                    setEditWorkData({
                      ...editWorkData,
                      description: e.target.value,
                    })
                  }
                />
              </div>

              <div className="row">
                {/* HEIGHT */}
                <div className="col-md-4">
                  <div className="vwk-pm-form-group">
                    <label>Height</label>

                    <input
                      type="number"
                      className="vwk-pm-input"
                      value={editWorkData.height}
                      onChange={(e) =>
                        setEditWorkData({
                          ...editWorkData,
                          height: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                {/* AREA */}
                <div className="col-md-4">
                  <div className="vwk-pm-form-group">
                    <label>Area</label>

                    <input
                      type="number"
                      className="vwk-pm-input"
                      value={editWorkData.area}
                      onChange={(e) =>
                        setEditWorkData({
                          ...editWorkData,
                          area: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                {/* COLOR */}
                <div className="col-md-4">
                  <div className="vwk-pm-form-group">
                    <label>Color</label>

                    <input
                      type="text"
                      className="vwk-pm-input"
                      value={editWorkData.color}
                      onChange={(e) =>
                        setEditWorkData({
                          ...editWorkData,
                          color: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              {/* EXISTING IMAGES */}
              <div className="vwk-pm-form-group">
                <label>Existing Images</label>

                {editWorkData.existing_images.length > 0 ? (
                  <div className="vwk-edit-images-grid">
                    {editWorkData.existing_images.map((img, index) => (
                      <div
                        className="vwk-edit-image-item"
                        key={`${img}-${index}`}
                      >
                        <img
                          src={`${UPLOAD_URL}/${editingWork.owner_id}/${img}`}
                          alt=""
                        />

                        <button
                          type="button"
                          className="vwk-edit-image-remove"
                          onClick={() => removeExistingWorkImage(index)}
                        >
                          <i className="bi bi-x-lg"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <small className="text-muted">No existing images.</small>
                )}
              </div>

              {/* NEW IMAGES */}
              <div className="vwk-pm-form-group">
                <label>Add New Images</label>

                <input
                  type="file"
                  className="vwk-pm-input"
                  multiple
                  accept="image/*"
                  onChange={(e) => {
                    const files = Array.from(e.target.files || []);

                    setEditWorkData((prev) => ({
                      ...prev,
                      new_images: [...prev.new_images, ...files],
                    }));

                    e.target.value = "";
                  }}
                />
              </div>

              {/* NEW IMAGE PREVIEW */}
              {editWorkData.new_images.length > 0 && (
                <div className="vwk-edit-images-grid">
                  {editWorkData.new_images.map((file, index) => (
                    <div
                      className="vwk-edit-image-item"
                      key={`${file.name}-${index}`}
                    >
                      <img src={URL.createObjectURL(file)} alt={file.name} />

                      <button
                        type="button"
                        className="vwk-edit-image-remove"
                        onClick={() => removeNewWorkImage(index)}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* FOOTER */}
            <div className="vwk-pm-footer">
              <button
                type="button"
                className="vwk-pm-btn vwk-pm-btn-cancel"
                onClick={() => {
                  setShowEditWorkModal(false);
                  setEditingWork(null);
                }}
              >
                Cancel
              </button>

              <button
                type="button"
                className="vwk-pm-btn vwk-pm-btn-submit"
                onClick={handleUpdateWork}
                disabled={editWorkSaving}
              >
                {editWorkSaving ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Updating...
                  </>
                ) : (
                  <>
                    <i className="bi bi-check-lg me-2"></i>
                    Update Work
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Bid Details Modal & Lightbox components retained as original... */}
    </div>
  );
}
